<template>
  <div>
    <a ref="lienDownload"></a>
    <div class="columns mgb-0 is-vcentered">
      <div class="has-text-weight-bold column is-9">
        {{ $t('detailOrdreTravailAffichage.annonceur.title', {
        nbAnnonceur: ordreTravail.annonceurs.length }) }}
      </div>
      <div class="column is-3">
        <div class="columns is-justify-content-end is-marginless">
          <a class="button is-primary mgr-2" v-if="displayAjouterFaceButton"
            @click="checkPermissions(permOrdreTravail.maj) ? ajouterFace()
                        : showPopUp()">
              <span class="is-size-7 ">
              {{$t('detailOrdreTravailAffichage.actions.ajouterFace')}}
              </span>
            </a>
            <slot name="otherAction"></slot>
            <exportExcelButton
              :perm="permOrdreTravail.exporter"
              :query="exportExcelQuery"
              :error-manager="exportExcelErrorManager"
              :errors.sync="error"
              class="mgr-2"/>
            <legendeOT></legendeOT>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-3" v-for="(annonceur, index) in ordreTravail.annonceurs" :key="index">
        <div class="card" :class="listIconAndColor[(annonceur.indexRegroupement - 1) % 24].class">
          <div class="card-content">
            <div class="columns is-vcentered is-min-height-64">
              <div class="column is-2">
                <b-icon :icon="listIconAndColor[(annonceur.indexRegroupement - 1) % 24].icon"
                        type="is-link" size="mdi-18px"></b-icon>
              </div>
              <div class="column is-6">
                <p class="has-text-link has-text-weight-bold ellipsis">
                  {{ annonceur.annonceurs }}
                </p>
                <p class="ellipsis" v-if="annonceur.theme" >
                  {{ annonceur.theme }}
                </p>
              </div>
              <div class="column is-narrow">
                <span class="has-text-weight-bold">
                  {{$t('detailOrdreTravailAffichage.annonceur.affichees')}}:
                  {{nbFacesAnnonceurs.get(annonceur.devisCommandeId).affichees}}
                </span><br/>
                <span class="is-size-7">
                  {{$t('detailOrdreTravailAffichage.annonceur.grattees')}}:
                  {{nbFacesAnnonceurs.get(annonceur.devisCommandeId).grattees}}
                </span><br/>
                <span class="is-size-7">
                  {{$t('detailOrdreTravailAffichage.annonceur.prevues')}}:
                  {{nbFacesAnnonceurs.get(annonceur.devisCommandeId).prevues}}
                  <span v-if="nbFacesAnnonceurs.get(annonceur.devisCommandeId).remplacer">
                    <b-tooltip :label="$t('detailOrdreTravailAffichage.annonceur.remplacees')">
                      ({{nbFacesAnnonceurs.get(annonceur.devisCommandeId).remplacer}})
                    </b-tooltip>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="error" class="mgt-20px"
      :error="error.length > 0"
      :title="'general.problemOccurred'"
      :withEmplyFields="true"
      @close="error = []"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import { LIST_ICON_AND_COLOR, EXPORT_EXCEL_ORDRE_TRAVAIL_AFFICHAGE, TYPE_EXPORT } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import legendeOT from '@/components/logistique/ordreTravail/affichage/legendeOT';
import { validationExportOt } from '@/services/logistique/ordreTravail/affichage/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'LogistiqueOrdreTravailAnnonceur',
  data() {
    return {
      permOrdreTravail: ORDRE_TRAVAIL,
      listIconAndColor: LIST_ICON_AND_COLOR,
      error: [],
    };
  },
  components: {
    legendeOT,
    errorMsgComponent,
    exportExcelButton,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    nbFacesAnnonceurs() {
      const dictionnaireNbFaces = new Map();
      this.ordreTravail.annonceurs.forEach(annonceur => {
        const faces = this.ordreTravail.faces.filter(f => {
          return f.affectationLogistiqueCommandeId === annonceur.devisCommandeId;
        });
        const nbFaces = {
          prevues: faces.filter(f => { return !f.remplacer; }).length,
          affichees: faces.filter(f => { return f.affichage; }).length,
          grattees: faces.filter(f => { return f.grattage; }).length,
          remplacer: faces.filter(f => { return f.remplacer; }).length,
        };
        dictionnaireNbFaces.set(annonceur.devisCommandeId, nbFaces);
      });
      return dictionnaireNbFaces;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_ORDRE_TRAVAIL_AFFICHAGE,
        typeExport: TYPE_EXPORT,
        parametresAdditionnels: {
          ordreTravailId: this.ordreTravail.id,
        },
      };
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getFacewithSameIndex(id) {
      return this.ordreTravail.faces.filter((face) => {
        return face.indexRegroupement === id;
      }).length;
    },
    async exportExcelErrorManager(e) {
      const errorResponseString = await readErrorBlobRequest(e.response.data);
      const response = JSON.parse(errorResponseString);
      validationExportOt(response, this.error);
    },
    ajouterFace() {
      this.$emit('ajouterFace');
    },
  },
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
    displayAjouterFaceButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
